module.exports = __webpack_public_path__ + "media/images/notification-a6972bd54cbddb2bd8a60d6dadaee335.svg";